var _HostFontWeightSelectorAPI_instances, _a, _HostFontWeightSelectorAPI_getFontFamilyAndWeight;
import { __classPrivateFieldGet } from "tslib";
const FONT_PROPERTIES = ['fontFamily', 'font'];
const FONT_WEIGHT_PROPERTIES = ['font-weight'];
export class HostFontWeightSelectorAPI {
    static isFontProperty(property) {
        return property ? FONT_PROPERTIES.includes(property) : false;
    }
    static isFontWeightProperty(property) {
        return property ? FONT_WEIGHT_PROPERTIES.includes(property) : false;
    }
    constructor(ps) {
        _HostFontWeightSelectorAPI_instances.add(this);
        this.ps = ps;
    }
    selectFontWeight(params, context) {
        const font = __classPrivateFieldGet(this, _HostFontWeightSelectorAPI_instances, "m", _HostFontWeightSelectorAPI_getFontFamilyAndWeight).call(this, params, context);
        return new Promise(async (resolve) => {
            const selectedFontWeight = await this.ps.hostAPI.editor.selectFontWeight({
                fontFamily: font,
            });
            resolve({
                ...font,
                weight: selectedFontWeight,
            });
        });
    }
    selectFont(params, context) {
        return new Promise(async (resolve) => {
            const font = context.styles[params.fontStyleItemKey]?.value;
            const showWeights = context.styleDefinitions[params.fontStyleItemKey]?.cssPropertyType ===
                'font';
            const newFont = await this.ps.hostAPI.editor.selectFontFamily({
                selectedFontFamily: font,
                showWeights,
            });
            resolve(newFont);
        });
    }
}
_a = HostFontWeightSelectorAPI, _HostFontWeightSelectorAPI_instances = new WeakSet(), _HostFontWeightSelectorAPI_getFontFamilyAndWeight = function _HostFontWeightSelectorAPI_getFontFamilyAndWeight(keys, context) {
    if (keys.fontFamilyStyleItemKey && keys.fontWeightStyleItemKey) {
        if (!_a.isFontProperty(keys.fontFamilyStyleItemKey) ||
            !_a.isFontWeightProperty(keys.fontWeightStyleItemKey)) {
            // TODO: throw error: unsupported property type https://wix.atlassian.net/browse/EP-6428
        }
        return {
            family: context.styles?.[keys.fontFamilyStyleItemKey]?.value.family,
            weight: context.styles?.[keys.fontWeightStyleItemKey]?.value.weight,
        };
    }
    if (keys.fontStyleItemKey) {
        if (!_a.isFontProperty(keys.fontStyleItemKey)) {
            // TODO: throw error: unsupported property type https://wix.atlassian.net/browse/EP-6428
        }
        return context.styles?.[keys.fontStyleItemKey]
            ?.value;
    }
    // TODO: throw error: invalid font family or weight style item key https://wix.atlassian.net/browse/EP-6428
    throw new Error('Invalid font family or weight style item key');
};
//# sourceMappingURL=HostFontWeightSelectorAPI.js.map